module.exports = __webpack_public_path__ + "img/weather05.e822205d.png";